import "bootstrap/dist/css/bootstrap.min.css";

import Header from "./Components/Header/Header";
import HeroSection from "./Components/HeroSection/HeroSection";

import Footer from "./Components/Footer/Footer";
import styled from "styled-components";
import CommonSection from "./Components/CommonSection/CommonSection";
import OurTeam from "./Components/OurTeam/OurTeam";

const Wrapper = styled.div``;
function App() {
  return (
    <Wrapper>
      <Header />
      <HeroSection />
      <CommonSection
        title="About US"
        text=" 8888 prestigious Moonbirds Azuki is a private membership community that will provide access to investment information & insight within moonbirds, Azuki & MAYC"
        img="./images/2.png"
        background="#3E689A"
     
      />{" "}
      <CommonSection
        title=" Phase 1"
        text=" 25% SOLD: We will acquire Moodbirds and Join their private community. We will be able to access more investment insight from Moonbirds Community. As you know, Moodbirds, Azuki, & Mutant Ape Club holders are all NFT Wales Holders. They exchange all the investment Insights within their Private Community."
        img="./images/3.png"
        background="#F9CD26"
        direction
      />{" "}
      <CommonSection
        title=" Phase 2"
        text=" 25% SOLD: We will acquire Moodbirds and Join their private community. We will be able to access more investment insight from Moonbirds Community. As you know, Moodbirds, Azuki, & Mutant Ape Club holders are all NFT Wales Holders. They exchange all the investment Insights within their Private Community."
        img="./images/4.png"
        background="#C4343E"
       
      />{" "}
      <CommonSection
        title=" Phase 3"
        text=" 75% SOLD: We will acquire Mutant Ape Yacht Club (MAYC) and join MAYC Private Community, access MAYC Community investment Insights to our Holders."
        img="./images/10.png"
        background="#1C6037"
        padding={true}
        direction
      />{" "}
      <CommonSection
        title=" Phase 4"
        title2="SandBox Metaverse"
        title3="Community DAO Owned"
        text=" Moonbirds Azuki will expand to the Sandbox Metaverse. We will buy a 3x3 land once the project is sold out. This land will be our HEADQUARTERS. "
        text2="Moonbirds Azuki holders will own and control the Moonbirds Azuki Metaverse governed through the community DAO."
        img="./images/6.png"
        background="#BC3039"
      
      />
      <OurTeam />
      <Footer />
    </Wrapper>
  );
}

export default App;
